export const REQUEST_STATUS = {
    PENDING: "PENDING",
    REJECTED: "REJECTED",
    ACCEPTED: "ACCEPTED",
};

export const REQUEST_STATUS_DICTIONARY = {
    [REQUEST_STATUS.PENDING]: "Pending",
    [REQUEST_STATUS.REJECTED]: "Rejected",
    [REQUEST_STATUS.ACCEPTED]: "Accepted",
};
